module.exports = __webpack_public_path__ + "media/stylesheets/images/staff/hero-mobile_4-8812bd56ef8beef61ed34507c4634eb8.png";